<template lang="pug">
  v-app
    div(class="main")
      div(class="main_banner_aside main_banner-left d-none d-lg-flex")
      div(class="main__content")
        div(class="main_banner-up")
        router-view
      div(class="main_banner_aside main_banner-right d-none d-lg-flex")
</template>
<script>
export default {
  created() {
    this.$store.dispatch('INITIALIZE')
    this.$store.dispatch(
      'GET_DISTRICT_LIST',
      JSON.parse(localStorage.filters).items.CityId
    )
    this.$store.dispatch('GET_CURRENCY_LIST')
    this.$store.dispatch('GET_NEW_PROPERTY_LIST')
  }
}
</script>
<style lang="scss">
* {
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  box-sizing: border-box;
}
.v-application {
  &--wrap {
    background: #fff !important;
  }
  .main {
    background: #fff !important;
    max-width: 1920px;
    width: 100vw;
    height: auto;
    display: flex;
    justify-content: center;
    &__content {
      max-width: 1000px;
      width: 100%;
      background: #fff !important;
      margin: 16px;
    }
    &_banner-up {
      max-width: 100%;
      height: 250px;
      background: url('./assets/banners/bunner_main_up.png') center center
        no-repeat;
      background-size: cover;
      border-radius: 6px;
      margin-bottom: 12px;
    }
    &_banner_aside {
      max-width: 200px;
      width: 100%;
      height: 600px;
      margin: 16px 0;
      border-radius: 6px;
      position: -webkit-sticky;
      position: sticky;
      top: 16px;
    }
    &_banner-left {
      background: red;
      margin-left: 8px;
    }
    &_banner-right {
      background: green;
      margin-right: 8px;
    }
    .v-toolbar__content {
      padding: 0;
    }
  }
  .v-select__selection {
    color: #8e8e93;
  }
  .v-text-field--solo {
    .v-icon {
      color: #8e8e93;
      font-size: 20px;
    }
    .v-input__control {
      min-height: 36px !important;
    }
    .v-input__slot {
      box-shadow: none !important;
      border: solid 1px #e5e5ea !important;
      margin: 0 !important;
    }
    .v-text-field__details {
      display: none;
    }
    label,
    input {
      font-size: 14px !important;
    }
    input {
      color: #8e8e93 !important;
    }
    .v-toolbar__content {
      padding: 0 !important;
    }
  }
  .v-btn {
    font-family: 'Open Sans', sans-serif;
    //font-size: 12px;
    text-transform: capitalize;
    letter-spacing: 0;
    &--disabled {
      color: white !important;
    }
  }
  .vel-modal {
    .vel-btns-wrapper {
      .btn__next,
      .btn__prev,
      .btn__close {
        opacity: 0.8;
        .vel-icon {
          width: 2em;
          height: 2em;
        }
      }
    }
  }
}
.new-advert-subtitle {
  font-weight: 700;
  font-size: 18px;
  line-height: 25px;
  letter-spacing: -0.944287px;
  color: #000000;
}
.toggle-buttons {
  width: 100%;
  .v-btn {
    width: 200px !important;
    height: 124px !important;
    border-radius: 6px !important;
    border: none !important;
    background-color: #e5e5ea !important;
    color: #8e8e93 !important;
    margin-bottom: 32px;
    margin-right: 32px;
    &--active {
      color: #fff !important;
      background-color: #07f !important;
      opacity: 1 !important;
      &:before {
        opacity: 0 !important;
      }
    }
    img {
      margin-bottom: 12px;
      width: 40px;
      height: 40px;
    }
    &-title {
      font-weight: 700;
    }
  }
}
</style>
